export default __webpack_public_path__ + "static/media/640_dummy2016-naeherin01-mobile-de.32af74a9.png";